import React, { useState, useEffect, useContext } from 'react';
import DataTable from '../components/DataTableComponents';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Tooltip } from '@mui/material';
import IconUI from '../components/iu/icon_ui';
import { AiOutlineEdit, AiOutlineDelete } from 'react-icons/ai';
import LoaderComponent from '../components/admin/LoaderComponent';
import { Box, Modal, TextField } from '@mui/material';
import { onlyLetter } from '../utils/inputsRules';
import { services } from '../services/api';
import { NotificacionContext } from '../context/notificacion_context';

const DelitosView = () => {
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',

        border: '2px solid #661d40',
        boxShadow: 24,
        p: 4,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        overflowY: "scroll",
        height: "auto",
        borderRadius: "40px",
    };

    const ColorButton = styled(Button)(({ theme }) => ({
        color: theme.palette.getContrastText('#005cbf'),
        backgroundColor: '#661d40',

        '&:hover': {
            backgroundColor: '#661d40',

        },
        borderRadius: "40px",

    }));

    const [state, setState] = useState({
        crimes: [],
        crimeSeleccionado: {},
        openEditar: false,
        openEliminar: false,
    });

    const [formularioState, setFormularioState] = useState({
        crime: '',
        crimeError: ''
    });

    const [loader, setLoader] = useState({
        loading: true
    });

    const [openModal, setopenModal] = useState(false)

    const openmodaleditar = (data) => {
        setState({ ...state, openEditar: true, crimeSeleccionado: data });
    }
    const openmodaleliminar = (data) => {
        setState({ ...state, openEliminar: true, crimeSeleccionado: data });
    }
    const handleCloseEditar = () => {
        setState({
            ...state, openEditar: false
        });
    }
    const handleCloseEliminar = () => {
        setState({
            ...state, openEliminar: false
        });
    }

    const { showNotification } = useContext(NotificacionContext)

    const columns = [
        {
            name: "tipo_crimen",
            label: "DELITO",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex) => {
                    let nombre = state.crimes[dataIndex].crime;
                    return (<div className='d-flex align-items-center' style={{ height: '60px' }}>{nombre}</div>)
                }
            }
        },

        {
            name: "acciones",
            label: "OPERACIONES",
            options: {
                filter: false,
                sort: false,
                download: false,
                customBodyRenderLite: (dataIndex, i) => (
                    <>
                        <div style={{ height: '60px' }} className="text-decoration-underline d-flex align-items-center">
                            <Tooltip title="EDITAR DELITO">
                                <div style={{ height: 30, width: 30, zIndex: 0, }} className='cta cta--primary cta--icon icon_btn'
                                    onClick={
                                        () => {
                                            openmodaleditar(state.crimes[dataIndex])
                                        }}
                                >
                                    <IconUI size={'20px'} color={'black'}><AiOutlineEdit /></IconUI>

                                </div>
                            </Tooltip>

                            <Tooltip title="ELIMINAR DELITO">
                                <div style={{ height: 30, width: 30, zIndex: 0, }} className='cta cta--primary cta--icon icon_btn'
                                    onClick={
                                        () => {
                                            openmodaleliminar(state.crimes[dataIndex])
                                        }}
                                >
                                    <IconUI size={'20px'} color={'black'}><AiOutlineDelete /></IconUI>

                                </div>
                            </Tooltip>

                        </div>
                    </>
                )
            }
        },

    ];

    const handleNombre = (e) => {
        setFormularioState({ ...formularioState, crime: e.target.value })
    }

    const handlePeticionSeleccionadoNombre = (e) => {
        const objeto = {
            id: state.crimeSeleccionado.id,
            crime: e.target.value,
        }
        setState({ ...state, crimeSeleccionado: objeto });
    }

    const validarFormulario = () => {
        const nombreError = formularioState.crime === '';
        // const atencionError = formularioState.atencion === '';
        return !nombreError
    }

    const crearPeticion = async () => {

        if (validarFormulario()) {
            setLoader({ loading: true })
            const Crimen = await services({
                method: 'POST', service: 'crimes', body: {
                    crime: formularioState.crime,
                }
            })
            if (Crimen.status === 201) {
                let peticiones = await services({ method: 'GET', service: `crimes`, body: null })
                if (peticiones) {
                    setLoader({ loading: false })
                    setFormularioState({ ...formularioState, crime: '' })
                    setState({ ...state, crimes: peticiones.data, open: false })
                    showNotification('success', 'Crímenes', 'Se creó correctamente el tipo de delito.', null, 4);
                    setopenModal(false);
                } else {
                    setLoader({loading: false})
                    showNotification('error', 'ups... Algo sucedió', 'Error al agregar delito', null, 4);
                    setFormularioState({ ...formularioState, crime: '' })
                    setopenModal(false);
                }
            } else {
                setLoader({ loading: false })
                showNotification('error', 'ups... Algo sucedió', 'Error al agregar delito', null, 4);
                setFormularioState({ ...formularioState, crime: '' })
                setopenModal(false);
            }
        } else {

            showNotification('error', 'ups...Error ', 'Por favor llena todos los campos', null, 4);
        }

    }

    const editarPeticion = async () => {
        if (state.crimeSeleccionado.crime === "") {
            showNotification('error', 'Ups... ', 'Favor de llenar los campos', null, 4);
        } else {
            setLoader({loading: true })
            const EditPeticion = await services({
                method: 'PUT', service: `crimes/${state.crimeSeleccionado.id}`, body: {
                    crime: state.crimeSeleccionado.crime?.toUpperCase(),
                }
            })
            if (EditPeticion.status === 200) {
                let peticiones = await services({ method: 'GET', service: `crimes`, body: null })
                setState({ ...state, crimes: peticiones.data, openEditar: false })
                showNotification('success', 'Crímenes', 'Se editó correctamente el tipo de delito.', null, 4);
                setLoader(false)
            } else {
                setState({ ...state, openEditar: false })
                setLoader(false)
                showNotification('error', 'ups...Error ', 'Ocurrio un error al editar el delito', null, 4);
            }
        }
    }

    const eliminarPeticion = async () => {
        setLoader(true)
        const EliminarPeticion = await services({ method: 'DELETE', service: `crimes/${state.crimeSeleccionado.id}`, body: null })
        if (EliminarPeticion) {
            setLoader(true)
            let peticiones = await services({ method: 'GET', service: `crimes`, body: null })
            if (peticiones) {
                setState({ ...state, crimes: peticiones.data, openEliminar: false })
                showNotification('success', 'Crímenes', 'Se eliminó correctamente el tipo de delito.', null, 4);
                setLoader(false)
            } else {
                setLoader(false)
                showNotification('error', 'ups...Error ', 'Ocurrió un error al eliminar el delito', null, 4);
            }

        } else {
            showNotification('error', 'ups...Error ', 'Ocurrió un error al eliminar el delito', null, 4);
            setLoader(false)
        }
    }

    const mostrarTipoDePeticiones = async () => {

        let peticiones = await services({ method: 'GET', service: `crimes`, body: null });

        if (peticiones) {
            setState({ ...state, crimes: peticiones.data })
            setLoader({ ...loader, loading: false })
        } else {
            showNotification('error', 'Ups...', 'No se logro cargar toda la información', null, 4);
            setLoader({ ...loader, loading: false })
        }
    }

    useEffect(() => {
        let isMounted = true
        if (isMounted) {
            mostrarTipoDePeticiones()
        }

        return () => {
            isMounted = false
        }
         // eslint-disable-next-line
    }, [])
    return (
        <>
            <div className=' justify-content-center align-items-start py-4'>

                {loader.loading &&
                    <LoaderComponent />
                }
                <div className='container'>
                    <Grid sx={{ marginTop: 3 }} container justifyContent="flex-end" alignItems="flex-end" spacing={2}>
                        <Grid item >
                            <ColorButton startIcon={<AddCircleOutlineIcon />} onClick={() => { setopenModal(true) }}>
                                Añadir Nuevo Delito
                            </ColorButton>
                        </Grid>
                    </Grid>
                </div>
                <DataTable
                    data={state.crimes}
                    title={`TABLA DE DELITOS`}
                    columns={columns}
                />

                <Modal
                    open={openModal}
                    onClose={() => setopenModal(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box className='contenedorModalUrs' sx={style}>

                        <h3 className='TitulosProgramas mb-3'>
                            NUEVO DELITO
                        </h3>
                        <Grid
                            container
                            columns={12}
                            spacing={4}
                        >
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    sx={{ borderRadius: "30px" }}
                                    fullWidth
                                    size='small'
                                    id="textFile-nombre"
                                    label="NOMBRE"
                                    variant="outlined"
                                    error={formularioState.crimeError}
                                    value={formularioState.crime.toUpperCase()}
                                    onChange={handleNombre}
                                    onKeyPress={(event) => {
                                        onlyLetter(event, 55);
                                    }}
                                />
                            </Grid>

                            <Grid marginLeft="auto" item >
                                <ColorButton onClick={() => {
                                    crearPeticion();
                                }}>
                                    Guardar
                                </ColorButton>
                            </Grid>
                        </Grid>
                    </Box>
                </Modal>

                <Modal
                    open={state.openEditar}
                    onClose={handleCloseEditar}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box className='contenedorModalUrs' sx={style}>
                        <h3 className='TitulosProgramas mb-3'>
                            EDITAR DELITO
                        </h3>
                        <Grid
                            container
                            columns={12}
                            spacing={3}
                        >

                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    size='small'
                                    id="textFile-nombre"
                                    label="NOMBRE"
                                    variant="outlined"
                                    InputLabelProps={{ shrink: true }}
                                    value={state.crimeSeleccionado.crime}
                                    onChange={handlePeticionSeleccionadoNombre}
                                    onKeyPress={(event) => {
                                        onlyLetter(event, 55);
                                    }}
                                />
                            </Grid>

                            <Grid marginLeft="auto" item >
                                <ColorButton onClick={() => {
                                    editarPeticion();

                                }}>
                                    Editar
                                </ColorButton>
                            </Grid>
                        </Grid>
                    </Box>
                </Modal>

                <Modal
                    open={state.openEliminar}
                    onClose={handleCloseEliminar}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box className='contenedorModalUrs text-center' sx={style}>
                        <h3 className='TitulosProgramas  mb-5'>
                            ¿ESTÁ SEGURO DE ELIMINAR EL DELITO?
                        </h3>
                        <Grid
                            container
                            columns={12}
                            spacing={4}
                        >

                            <Grid item xs={12}>
                                <h4>
                                    {state.crimeSeleccionado.crime}
                                </h4>
                            </Grid>

                            <Grid margin="auto" item >
                                <ColorButton onClick={() => {
                                    eliminarPeticion();
                                }}>
                                    Eliminar
                                </ColorButton>
                            </Grid>
                        </Grid>
                    </Box>
                </Modal>

            </div>
        </>
    )
}

export default DelitosView
